import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Fab from "@material-ui/core/Fab";
import EditIcon from "@material-ui/icons/Edit";
import { withStyles } from "@material-ui/core/styles";
import { Formik, Form } from "formik";
import { Mutation, compose } from "react-apollo";
import gql from "graphql-tag";
import { withNotification } from "../notification/context";

const EDIT_VALUE = gql`
  mutation($id: ID!, $value: Float!) {
    editStatsValue(id: $id, value: $value) {
      id
      value
      resource {
        name
      }
      probabilityValue
      typing
      year
      description
      indicator {
        name
      }
    }
  }
`;

const styles = theme => ({
  fab: {
    margin: theme.spacing.unit
  }
});

const StatsEditModal = ({
  row,
  classes,
  openNotification,
  query,
  variables
}) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Mutation
      mutation={EDIT_VALUE}
      update={(cache, { data: { editStatsValue } }) => {
        const { stats } = cache.readQuery({ query, variables });
        const statsClean = {
          ...stats,
          data: [editStatsValue].concat(
            stats.data.filter(item => item.id !== editStatsValue.id)
          )
        };
        cache.writeQuery({
          variables,
          query,
          data: { stats: statsClean }
        });
      }}
    >
      {editValue => (
        <Formik
          initialValues={row}
          onSubmit={({ id, value }, actions) => {
            editValue({ variables: { id, value } })
              .then(() => {
                openNotification("Valor actualizado correctamente.");
                handleClose();
              })
              .catch(() => {
                openNotification("Error actualizando el valor estadístico.");
                handleClose();
              });
          }}
        >
          {({ values, handleChange, handleSubmit }) => {
            return (
              <Form>
                <Fab
                  size="small"
                  aria-label="Edit"
                  className={classes.fab}
                  onClick={handleClickOpen}
                >
                  <EditIcon />
                </Fab>
                <Dialog
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="form-dialog-title"
                >
                  <DialogTitle id="form-dialog-title">
                    Editar valor estadístico
                  </DialogTitle>
                  <DialogContent>
                    <TextField
                      id="value"
                      label="Valor"
                      type="number"
                      value={values.value}
                      onChange={handleChange}
                      margin="normal"
                      variant="outlined"
                    />
                  </DialogContent>
                  <DialogActions>
                    <Button onClick={handleClose} color="primary">
                      Cancelar
                    </Button>
                    <Button onClick={handleSubmit} color="primary">
                      Actualizar
                    </Button>
                  </DialogActions>
                </Dialog>
              </Form>
            );
          }}
        </Formik>
      )}
    </Mutation>
  );
};

export default compose(
  withStyles(styles),
  withNotification
)(StatsEditModal);



// WEBPACK FOOTER //
// ./src/components/stats/stats-edit-modal.js